module.exports = __webpack_public_path__ + "media/images/site/terceirao-3-a41d07734a236adc6c208fda37f27a5b.jpg";